<span class="text-truncate">{{ displayName() }}</span>
<i class="mdi mdi-help-circle-outline"></i>
